/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessagingAdapter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 3h20v8h-2V6.045l-8 6.222-8-6.222V19h4v2H2zm3.915 2L12 9.733 18.085 5zM16.5 15a2.5 2.5 0 0 0 0 5H18v-5zm3.5 2v1h2v2h-2v2h-3.5a4.502 4.502 0 0 1-4.388-3.5H10v-2h2.111A4.502 4.502 0 0 1 16.5 13H20v2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMessagingAdapter as MessagingAdapter };
